import React from 'react'
import { syncedInterval, clearSyncedInterval } from 'utils'

export interface IntervalWrapperProps {
  render: () => JSX.Element | null
}

export class IntervalWrapper extends React.Component<IntervalWrapperProps> {
  private timer: string | null = null

  componentDidMount() {
    this.timer = syncedInterval(() => this.forceUpdate())
  }

  componentWillUnmount() {
    clearSyncedInterval(this.timer!)
    this.timer = null
  }

  render() {
    return this.props.render()
  }
}
